import * as React from "react";
import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import Actions from "../../../redux/Actions";
import HelpBox from "./HelpBox";
import { History } from "history";
import School from "../../../models/School";
import { SchoolTheme } from "../onboard/SchoolTheme";
import { SchoolThemeCard } from "../onboard/SchoolThemeCard";
import { SchoolLogoCard } from "../onboard/SchoolLogoCard";
import { CommandBarButton, MessageBarType } from "office-ui-fabric-react/lib-commonjs";
import SchoolPageTitle from "../../SchoolPageTitle";
import AdminSchoolMenu from "../../AdminSchoolMenu";

interface SchoolThemePageProps {
    tenantId: string;
    schoolCode: string;
 
    apiService: ApiService;
    history: History;
}

interface SchoolThemePageState {
    school?: School;
    updatedSchoolTheme?: SchoolTheme;
    updatedSchoolLogo?: File;
    schoolLogoSet: boolean;
    currentLogo?: File;
    themeButtonDisabled: boolean;
    logoButtonDisabled: boolean;
}

class SchoolThemePage extends Component<SchoolThemePageProps & DispatchProps, SchoolThemePageState> {

    constructor(props: SchoolThemePageProps & DispatchProps) {
        super(props);
        this.state = {
            school: undefined,
            updatedSchoolTheme: undefined,
            updatedSchoolLogo: undefined,
            schoolLogoSet: false,
            currentLogo: undefined,
            themeButtonDisabled: false,
            logoButtonDisabled: false
        };

    }

    async componentDidMount(): Promise<void> {
            
        const school = this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode);
        this.setState({
            school
        });

        const theme = await this.props.apiService.getSchoolTheme(this.props.tenantId, this.props.schoolCode);
        const image = await this.props.apiService.getSchoolLogo(this.props.tenantId, this.props.schoolCode);

        this.setState({
            updatedSchoolTheme: theme,
            currentLogo: image,
            schoolLogoSet: image == undefined ? false : true
        });

    }

    async componentDidUpdate(prevProps: Readonly<SchoolThemePageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    private saveLogo = async (): Promise<void> => {
        
        if (this.state.updatedSchoolLogo == null && this.state.schoolLogoSet) {
            //They already had a logo set
            this.props.dispatch(Actions.showMessageBar(`Logo has not been changed. No logo to save`, MessageBarType.success));
            return;
        }

        try {
            if (this.props.tenantId != null && this.props.schoolCode != null && this.state.updatedSchoolLogo != null) {
                this.setState({ logoButtonDisabled: true })
                await this.props.apiService.putSchoolLogo(this.props.tenantId, this.props.schoolCode, this.state.updatedSchoolLogo);

                this.props.dispatch(Actions.showMessageBar(`Saved School Logo`, MessageBarType.success));
            }
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to save School Logo : ${e.message}`, MessageBarType.error));
        }
        this.setState({ logoButtonDisabled: false })
    }

    private saveTheme = async (): Promise<void> => {
        

        if (!this.state.updatedSchoolTheme) {
            return;
        }

        try {
            this.setState({ themeButtonDisabled: true })
            await this.props.apiService.putSchoolTheme(this.props.tenantId, this.props.schoolCode, this.state.updatedSchoolTheme);

            this.props.dispatch(Actions.showMessageBar(`Saved School Theme`, MessageBarType.success));
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to save School Theme : ${e.message}`, MessageBarType.error));
        }
        this.setState({ themeButtonDisabled: false })
    }

    private onSchoolThemeChanged = (updatedSchoolTheme: SchoolTheme): void => {
        this.setState({
            updatedSchoolTheme: updatedSchoolTheme
        });
    }

    private onSchoolLogoChanged = (updatedSchoolLogo: File | undefined, logoSet: boolean): void => {
        this.setState({
            updatedSchoolLogo: updatedSchoolLogo,
            schoolLogoSet: logoSet
        });
    }

    public render(): JSX.Element {

        const schoolLogoCard = this.state.school
            ? <SchoolLogoCard
                onSchoolLogoChanged={this.onSchoolLogoChanged}
                school={this.state.school}
                currentLogo={this.state.currentLogo}
                megaMenuBgColour={this.state.updatedSchoolTheme?.megaMenuBgColour}
                megaMenuFontColour={this.state.updatedSchoolTheme?.megaMenuFontColour}>
                <CommandBarButton
                    text="Save"
                    iconProps={{ iconName: "save" }}
                    onClick={this.saveLogo}
                    disabled={this.state.logoButtonDisabled}
                />
                </SchoolLogoCard>
            : null;

        const schoolThemeCard = this.state.updatedSchoolTheme && this.state.school
            ? <SchoolThemeCard
                  schoolTheme={this.state.updatedSchoolTheme}
                  onSchoolThemeChanged={this.onSchoolThemeChanged}
                school={this.state.school}>
                <CommandBarButton
                    text="Save"
                    iconProps={{ iconName: "save" }}
                    onClick={this.saveTheme}
                    disabled={this.state.themeButtonDisabled}
                />
                </SchoolThemeCard>
            : null;

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Theme" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <HelpBox TitleText="Edit School Theme" Icon="EditCreate" HelpBoxText="This page allows you to change the school theme and school logo. Once the changes have been made hitting the save button will start the workload and apply the theme please be sure the theme is correct before running."/>
                <div className={"flex-item--flex-1"}>
                    {schoolLogoCard}
                </div>
                <div className={"flex-item--flex-1"}>
                    {schoolThemeCard}
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): SchoolThemePageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history
        };

    }
)(SchoolThemePage)